<template>
  <div class="csat">
    <div
      class="clever-tab"
      :class="{ 'clever-tab--single': tabsActive.length === 1 }"
    >
      <ul class="clever-tab__tabs">
        <li
          v-for="(tab, index) in tabsActive"
          :key="tab.id"
          class="clever-tab__tabs__item"
          :class="{ 'clever-tab__tabs__item--active': tab.id === tabActive }"
          :style="`z-index:${19 - index}`"
        >
          <a
            :href="`#${tab.id}`"
            @click.prevent="selectTab($event)"
            v-html="tab.label"
          />
        </li>
      </ul>

      <div class="clever-tab__content">
        <!-- Loader -->
        <div
          v-if="isLoading"
          class="csat__loader"
        >
          <BaseLoader/>
        </div>

        <!-- Tab Self -->
        <div
          id="tab-csat-self"
          class="clever-tab__content__item"
          v-if="tabActive === 'tab-csat-self'"
        >
          <div
            v-if="isSelfEmpty"
            class="csat__empty-state"
          >
            <span>
              Você ainda não recebeu<br>nenhuma avaliação.
            </span>
          </div>

          <ul
            v-else
            class="csat__list"
          >
            <li
              v-for="item in selfData"
              :key="item.date"
              class="csat__list__item"
            >
              <div class="csat__list__item__details">
                <div class="csat__list__item__details__name">
                  {{ item.name | prunedName }}
                </div>

                <div class="csat__list__item__details__when">
                  {{ formatDate(item.date) }}
                </div>

                <div
                  class="csat__list__item__details__rating"
                  :class="`csat__list__item__details__rating--${item.evaluation}`"
                  :title="`Nota ${item.evaluation}`"
                >
                  <SvgIconStar
                    v-for="i in 5"
                    :key="i"
                  />
                </div>
              </div>

              <div
                v-if="item.details"
                class="csat__list__item__message"
              >
                {{ item.details }}
              </div>
            </li>
          </ul>
        </div>

        <!-- Tab General -->
        <div
          id="tab-csat-general"
          class="clever-tab__content__item"
          v-if="tabActive === 'tab-csat-general'"
        >
          <div
            v-if="isGeneralEmpty"
            class="csat__empty-state"
          >
            <span>
              Você ainda não recebeu<br>nenhuma avaliação.
            </span>
          </div>

          <ul
            v-else
            class="csat__list"
          >
            <li
              v-for="item in generalData"
              :key="item.date"
              class="csat__list__item"
            >
              <div class="csat__list__item__details">
                <div class="csat__list__item__details__name">
                  {{ item.name | prunedName }}
                </div>

                <div class="csat__list__item__details__when">
                  {{ formatDate(item.date) }}
                </div>

                <div
                  class="csat__list__item__details__rating"
                  :class="`csat__list__item__details__rating--${item.evaluation}`"
                  :title="`Nota ${item.evaluation}`"
                >
                  <SvgIconStar
                    v-for="i in 5"
                    :key="i"
                  />
                </div>
              </div>

              <div
                v-if="item.details"
                class="csat__list__item__message"
              >
                {{ item.details }}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import BaseLoader from '@/components/base/BaseLoader.vue'

export default {
  name: 'WidgetCsat',

  components: {
    BaseLoader
  },

  data () {
    return {
      tabs: [
        {
          id: 'tab-csat-self',
          label: 'Avaliações do<br>meu atendimento',
          allowedFeature: 'widget-csat-commissions'
        },
        {
          id: 'tab-csat-general',
          label: 'Avaliações da<br>WeClever',
          allowedFeature: 'widget-csat-commissions'
        },
        {
          id: 'tab-csat-general',
          label: 'Avaliações dos clientes sobre os atendimentos',
          allowedFeature: 'widget-csat-performance'
        }
      ],
      tabActive: null,
      timeInterval: 60000,
      fetchingInterval: null,
      isLoading: false,
      selfData: null,
      generalData: null
    }
  },

  computed: {
    ...mapGetters('auth', ['allowedFeature']),

    isSelfEmpty () {
      return Boolean(!this.selfData?.length)
    },

    isGeneralEmpty () {
      return Boolean(!this.generalData?.length)
    },

    tabsActive () {
      return this.tabs
        .map(tab => {
          tab.isActive = this.allowedFeature(tab.allowedFeature)

          return tab
        })
        .filter(tab => tab.isActive === true)
    }
  },

  methods: {
    resetTabs () {
      this.tabActive = this.tabsActive[0].id
    },

    selectTab (event) {
      const tabSelected = event.currentTarget.getAttribute('href').replace(/^#/, '')

      if (this.tabActive === tabSelected) {
        return
      }

      this.tabActive = tabSelected

      this.initTabs()
    },

    initTabs () {
      this.finishTabs()
      this.fetchController()

      this.fetchingInterval = setInterval(this.fetchController, this.timeInterval);
    },

    finishTabs () {
      if (this.fetchingInterval) {
        clearInterval(this.fetchingInterval)
      }
    },

    fetchSelf () {
      const api = process.env.VUE_APP_ROOT_API
      const { id_user: userId } = this.$auth.user()
      const url = api + 'lead/widget-csat/evaluation/user/' + userId

      this.isLoading = true

      const response = axios
        .get(url)
        .then(({ data }) => {
          const container = document.querySelector('#tab-csat-self')

          this.selfData = data

          if (container) container.scrollTop = 0
        })
        .catch(error => {
          throw error
        })
        .then(() => {
          this.isLoading = false
        })
    },

    fetchGeneral () {
      const api = process.env.VUE_APP_ROOT_API
      const url = api + 'lead/widget-csat/evaluation'

      this.isLoading = true

      const response = axios
        .get(url)
        .then(({ data }) => {
          const container = document.querySelector('#tab-csat-general')

          this.generalData = data

          if (container) container.scrollTop = 0
        })
        .catch(error => {
          throw error
        })
        .then(() => {
          this.isLoading = false
        })
    },

    fetchController () {
      if (!this.fetchingInterval) {
        if (this.tabsActive.length > 1) {
          this.fetchSelf()
        }

        this.fetchGeneral()

        return
      }

      switch (this.tabActive) {
        case 'tab-csat-self':
          this.fetchSelf()
          break

        case 'tab-csat-general':
          this.fetchGeneral()
      }
    },

    formatDate (date) {
      let [day, time] = new Date(date).toLocaleString('pt-BR').split(' ')
      const [today] = new Date().toLocaleString('pt-BR').split(' ')

      if (day === today) {
        day = 'Hoje'
      }

      return `${day} ${time}`
    }
  },

  filters: {
    prunedName (value) {
      if (!value) {
        return ''
      }

      const firstName = value
        .toString()
        .trim()
        .replace(/^(.+?)\s.+$/, '$1')
        .toLowerCase()

      return firstName.charAt(0).toUpperCase() + firstName.slice(1)
    }
  },

  mounted () {
    this.resetTabs()
    this.initTabs()
  },

  beforeDestroy () {
    this.finishTabs()
  }
}
</script>

<style lang="scss" scoped>
.csat {
  $color-1: #98c1dd;
  $color-2: #ecece2;

  font: {
    size: 14px;
    family: 'Montserrat';
  }

  &__loader {
    position: absolute;
    bottom: -40px;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0.3;

    svg {
      width: 50px;
    }
  }

  &__empty-state {
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
    border-radius: 24px;
    background: #fff;
    font-size: 14px;
    line-height: 130%;
    text-align: center;

    span {
      display: block;
      width: 100%;
      max-width: 235px;
      padding-top: 50px;
      background: {
        image: url('~@/assets/img/widget-csat/empty-stars.svg');
        position: 50% 0;
        repeat: no-repeat;
      }
    }
  }

  &__list {
    padding: 0;

    &__item {
      display: block;
      padding: 20px;
      border: 1px solid $color-2;
      border-radius: 24px;
      background: #fff;

      &:nth-child(n + 2) {
        margin-top: 15px;
      }

      &__details {
        display: flex;
        gap: 10px;

        &__name {
          font-weight: 700;
        }

        &__when {
          flex-grow: 1;
          color: $color-1;
        }

        &__rating {
          svg {
            margin-left: 3px;
            fill: $color-2;
          }

          &--1 {
            svg {
              &:first-child {
                fill: $color-1;
              }
            }
          }

          &--2 {
            svg {
              &:nth-child(-n + 2) {
                fill: $color-1;
              }
            }
          }

          &--3 {
            svg {
              &:nth-child(-n + 3) {
                fill: $color-1;
              }
            }
          }

          &--4 {
            svg {
              &:nth-child(-n + 4) {
                fill: $color-1;
              }
            }
          }

          &--5 {
            svg {
              fill: $color-1;
            }
          }
        }
      }

      &__message {
        margin-top: 10px;
        line-height: 130%;
      }
    }
  }
}
</style>
